import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { LegalTechnologyUnlawfulUseModel } from './types';
import { legalTechnologyUnlawfulUseItemValidator } from './validators/item';

const legalTechnologyUnlawfulUseValidator: ValidateJSModel<LegalTechnologyUnlawfulUseModel> = {
  HasUnlawful: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.HasUnlawful && attributes?.HasUnlawful.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalTechnologyUnlawfulUseItemValidator },
      };
    }
    return {};
  },
};

export default legalTechnologyUnlawfulUseValidator;
